import React from "react";
import { Cell, Pie, PieChart } from "recharts";

const CustomPieChart = ({ data = [], labelText = "", labelValue = 0 }) => {
  const totalPercentage = data.reduce((sum, d) => sum + (d.percentage || 0), 0);
  const filler = {
    name: "Remaining",
    percentage: Math.max(0, 100 - totalPercentage),
    colour_code: "#e0e0e0",
    count: "Remaining",
    total: "",
  };

  const processedData = [...data, filler];
  return (
    <PieChart width={200} height={200}>
      <Pie
        data={processedData}
        innerRadius={55}
        outerRadius={80}
        paddingAngle={3}
        dataKey="percentage"
        isAnimationActive={false}
      >
        {processedData.map((entry, index) => {
          return (
            <Cell key={`cell-${index}`} fill={entry.colour_code || "#ccc"} />
          );
        })}
      </Pie>

      <text
        x="50%"
        y="46%"
        textAnchor="middle"
        dominantBaseline="middle"
        style={{ fontSize: "12px", fill: "#5B626C" }}
      >
        {labelText}
      </text>
      <text
        x="50%"
        y="54%"
        textAnchor="middle"
        dominantBaseline="middle"
        style={{
          fontSize: "14px",
          fill: "#000",
          fontWeight: 600,
        }}
      >
        {labelValue}
      </text>
    </PieChart>
  );
};

export default CustomPieChart;
